<script>
    import { createEventDispatcher, onMount } from "svelte";

    export let id = "";
    export let width = "normal";
    export let title = undefined;
    export let offsetTopLeft = 0;

    let moving = false;
    let movingX = 0;
    let movingY = 0;
    let start = undefined;
    let modalZIndex = 60;
    let backdropZIndex = 50;

    const dispatch = createEventDispatcher();

    function closeModal() {
        dispatch("cancel");
    }

    onMount(() => {
        const win = document.getElementById("modalWindow" + id);
        const backdrop = document.getElementById("modalBackdrop" + id);
        if (!!win && !!backdrop) {
            /*
            const winRect = win.getBoundingClientRect();
            if (winRect.x + offsetTopLeft > 0) {
                win.style.left = winRect.x + offsetTopLeft + "px";
            }
            if (winRect.y + offsetTopLeft > 0) {
                win.style.top = winRect.y + offsetTopLeft + "px";
            }
            */

            win.style.zIndex = (modalZIndex + offsetTopLeft).toString();
            backdrop.style.zIndex = (backdropZIndex + offsetTopLeft).toString();
        }
    });

    function modalClass(w) {
        switch (w) {
            case "wide":
                return "modal-wide";
            case "wider":
                return "modal-wider";
            case "small":
                return "modal-small";
        }
        return "modal-normal";
    }

    function doStartDrag(event) {
        moving = true;
        movingX = event.clientX;
        movingY = event.clientY;
        start = document
            .getElementById("modalWindow" + id)
            .getBoundingClientRect();
    }

    function doDrag(event) {
        let mw = document.getElementById("modalWindow" + id);
        if (moving && !!mw) {
            mw.style.top = start.y + event.clientY - movingY + "px";
            mw.style.left = start.x + event.clientX - movingX + "px";
        }
    }

    function doStopDrag() {
        moving = false;
    }
</script>

<svelte:window on:mousemove={doDrag} on:mouseup={doStopDrag} />
<div id="modalBackdrop{id}" class="modal-backdrop" on:click={closeModal} />
<div id="modalWindow{id}" class="modal {modalClass(width)}">
    <div class="title" on:mousedown={doStartDrag}>{!!title ? title : ""}</div>
    <div class="content">
        <slot />
    </div>
    <footer>
        <slot name="footer" />
    </footer>
</div>

<style>
    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: rgba(0, 0, 0, 0.55);
        z-index: 50;
    }

    .modal {
        position: fixed;
        top: var(--branding-height);
        max-height: calc(100vh - var(--branding-height));
        background: var(--background-active);
        border-radius: 5px;
        z-index: 60;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
        overflow: hidden;
    }

    .title {
        cursor: move;
        color: white;
        background-color: var(--accent-color);
        padding: 0.5rem;
    }

    .content {
        padding: 0.5rem;
    }

    .modal-normal,
    .modal-wide,
    .modal-wider,
    .modal-small {
        width: 100%;
        left: 0;
    }

    @media (min-width: 600px) {
        .modal-normal {
            width: calc(0.6 * min(var(--body-max-width), 100vw));
            left: calc(50vw - (0.3 * min(var(--body-max-width), 100vw)));
        }

        .modal-wide {
             width: calc(0.9 * min(var(--body-max-width), 100vw));
            left: calc(50vw - (0.45 * min(var(--body-max-width), 100vw)));
        }

        .modal-wider {
            width: calc(0.8 * min(var(--body-max-width), 100vw));
            left: calc(50vw - (0.4 * min(var(--body-max-width), 100vw)));
        }

        .modal-small {
             width: calc(0.5 * min(var(--body-max-width), 100vw));
            left: calc(50vw - (0.25 * min(var(--body-max-width), 100vw)));
        }
    }
</style>
